var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 57,
    viewBox: "0 0 70 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 27.1719H6.15417C6.69623 23.562 7.98522 20.1049 9.9388 17.0214C11.8924 13.9378 14.4676 11.2956 17.5 9.26354L22.7208 5.76354L19.5125 0.921875L14.2917 4.42187C9.89706 7.35043 6.29332 11.3185 3.80022 15.974C1.30712 20.6295 0.00177067 25.8284 0 31.1094V50.5052C0 52.0523 0.614581 53.536 1.70854 54.63C2.80251 55.724 4.28624 56.3385 5.83333 56.3385H23.3333C24.8804 56.3385 26.3642 55.724 27.4581 54.63C28.5521 53.536 29.1667 52.0523 29.1667 50.5052V33.0052C29.1667 31.4581 28.5521 29.9744 27.4581 28.8804C26.3642 27.7865 24.8804 27.1719 23.3333 27.1719Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1663 27.1719H46.9872C47.5292 23.562 48.8182 20.1049 50.7718 17.0214C52.7254 13.9378 55.3006 11.2956 58.333 9.26354L63.5538 5.76354L60.3747 0.921875L55.1247 4.42187C50.7301 7.35043 47.1263 11.3185 44.6332 15.974C42.1401 20.6295 40.8348 25.8284 40.833 31.1094V50.5052C40.833 52.0523 41.4476 53.536 42.5416 54.63C43.6355 55.724 45.1192 56.3385 46.6663 56.3385H64.1663C65.7134 56.3385 67.1972 55.724 68.2911 54.63C69.3851 53.536 69.9997 52.0523 69.9997 50.5052V33.0052C69.9997 31.4581 69.3851 29.9744 68.2911 28.8804C67.1972 27.7865 65.7134 27.1719 64.1663 27.1719Z",
    fill: "white",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.a33a34d3e7a3ad8ff2ce6ac6ff0490b2.svg";
export { ForwardRef as ReactComponent };